export default __webpack_public_path__ + "static/media/Z_wdt_c_cap_0.6a264d35.mp3";